import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectTextColorOption')(function selectTextColorOption(color, state) {
    var optionState = state.optionState;
    optionState.fontColor = color;
}));
//# sourceMappingURL=selectTextColorOption.js.map